import { getAvatarInitials } from '@/services/organization';
import { Avatar, Box, FileInput } from '@mantine/core';
import { useState, useRef, useEffect } from 'react';

interface AvatarPreviewProps {
  value?: File | null;
  onChange?: (file: File | null) => void;
  givenName?: string;
  familyName?: string;
  size?: number;
}

export function AvatarPreview({ value, onChange, givenName = '', familyName = '', size = 42 }: AvatarPreviewProps) {
  const [preview, setPreview] = useState<string | null>(null);
  const inputRef = useRef<HTMLButtonElement>(null); // <-- matches Mantine FileInput

  useEffect(() => {
    if (value) {
      const reader = new FileReader();
      reader.onload = (e) => setPreview(e.target?.result as string);
      reader.readAsDataURL(value);
    } else {
      setPreview(null);
    }
  }, [value]);

  return (
    <Box
      onClick={() => inputRef.current?.click()} // open the file picker programmatically
      style={{ cursor: 'pointer', flexShrink: 0 }}
    >
      <FileInput
        ref={inputRef} // Mantine expects HTMLButtonElement
        value={value}
        onChange={onChange}
        accept="image/*"
        display="none"
      />
      {preview ? (
        <img
          src={preview}
          alt="Avatar preview"
          style={{
            width: size,
            height: size,
            borderRadius: '50%',
            objectFit: 'cover',
            border: '1px solid #e0e0e0',
          }}
        />
      ) : (
        <Avatar size={size} src={preview} name={getAvatarInitials({ given: [givenName], family: familyName })} />
      )}
    </Box>
  );
}
